import { Box } from "@mui/material";

const EngagementDashboard = () => {
  return <Box>Engagement dashboard not implemented</Box>;
};
export default EngagementDashboard;
